/** BBRewardFeedSource — reward-feed 的 sources 筛选项，List 与 Section 共用 */
export const BB_REWARD_FEED_SOURCES = [
  'TASK',
  'WHEEL',
  'BOX',
  'LOTTERY',
  'LOGIN',
  'TRADE',
  'BOX_OPEN',
  'INVITE',
  'SOCIAL',
  'LEADERBOARD',
  'BOX_REWARD',
  'PERP_TOP',
  'PREDICT_TOP',
  'LEVERAGE_TOP',
  'TAP_GRID_TOP',
  // 通配：匹配该组下所有 *_VOLUME_<threshold> 具体来源
  'TRADING_VOLUME',
  'PREDICT_VOLUME',
  'LEVERAGE_VOLUME',
  'TAP_GRID_VOLUME',
] as const;

export type BbRewardFeedSource = (typeof BB_REWARD_FEED_SOURCES)[number];

export const BB_REWARD_FEED_STATUSES = [
  'PENDING',
  'UNDER_REVIEW',
  'DISTRIBUTED',
  'REJECTED',
] as const;

export const BB_REWARD_FEED_TYPES = ['GRANT', 'WIN', 'XP', 'LOTTERY_TICKET'] as const;
